import { merge, unionBy } from 'lodash';
import * as Actions from '../actions';
import { Action, SettingsProfileType } from '../models';
import { SettingsProfileState, defaultState, namespace } from '../store';
import { createReducer } from '@reduxjs/toolkit';
import { DEFAULT_GLOBAL_SETTINGS } from '@helpers/constants';

const fetchProfileListRequest = (state: SettingsProfileState) => ({
  ...state,
  isFetchProfileListInProgress: true,
});

const fetchProfileListSuccess = (
  state: SettingsProfileState,
  action: ReturnType<typeof Actions.FETCH_PROFILE_LIST_SUCCESS>
  // action: Action<
  //   {
  //     structuredDataObjects: { count: number; records: SettingsProfileType[] };
  //   },
  //   { variables: { limit: number; offset: number } }
  // >
) => {
  const { count, records } = action.payload.structuredDataObjects;

  // merge profile settings with default GlobalSettings in case new keys have been added
  const profileList = (records || []).map((r) => ({
    ...r,
    data: {
      ...r.data,
      settings: merge({}, DEFAULT_GLOBAL_SETTINGS, r.data.settings),
    },
  }));

  const { limit } = action.meta.variables;
  const updatedState = {
    ...state,
    profileList: unionBy(profileList, state.profileList || [], 'id'),
    isFetchProfileListInProgress: limit === count,
  };
  return updatedState;
};

const fetchProfileListFailure = (state: SettingsProfileState) => ({
  ...state,
  isFetchProfileListInProgress: false,
});

const createSettingsProfileSuccess = (
  state: SettingsProfileState,
  action: Action<{ createStructuredData: SettingsProfileType }, unknown>
) => {
  const updatedState = {
    ...state,
    profileList: [
      ...(state.profileList || []),
      { ...action.payload.createStructuredData },
    ],
  };
  return updatedState;
};

const updateSettingsProfileSuccess = (
  state: SettingsProfileState,
  action: Action<{ createStructuredData: SettingsProfileType }, unknown>
) => {
  const updatedState = {
    ...state,
    profileList: [
      ...state.profileList.map((p) => {
        if (p.id === action.payload.createStructuredData.id) {
          return { ...action.payload.createStructuredData };
        }
        return p;
      }),
    ],
  };
  return updatedState;
};

const deleteSettingsProfileSuccess = (
  state: SettingsProfileState,
  action: Action<{ deleteStructuredData: { id: string } }, unknown>
) => {
  const updatedState = {
    ...state,
    profileList: [
      ...[...state.profileList].filter(
        (p) => p.id !== action.payload?.deleteStructuredData?.id
      ),
    ],
  };
  return updatedState;
};

export const settingsProfileReducer = {
  [namespace]: createReducer(defaultState, (builder) => {
    builder
      .addCase(Actions.FETCH_PROFILE_LIST_REQUEST, fetchProfileListRequest)
      .addCase(Actions.FETCH_PROFILE_LIST_SUCCESS, fetchProfileListSuccess)
      .addCase(Actions.FETCH_PROFILE_LIST_FAILURE, fetchProfileListFailure)
      .addCase(
        Actions.CREATE_SETTINGS_PROFILE_SUCCESS,
        createSettingsProfileSuccess
      )
      .addCase(
        Actions.UPDATE_SETTINGS_PROFILE_SUCCESS,
        updateSettingsProfileSuccess
      )
      .addCase(
        Actions.DELETE_SETTINGS_PROFILE_SUCCESS,
        deleteSettingsProfileSuccess
      );
  }),
};
